import { render, staticRenderFns } from "./index_child.vue?vue&type=template&id=3ca88ceb&scoped=true"
import script from "./index_child.vue?vue&type=script&lang=js"
export * from "./index_child.vue?vue&type=script&lang=js"
import style0 from "./index_child.vue?vue&type=style&index=0&id=3ca88ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca88ceb",
  null
  
)

export default component.exports